/** English of the interface (ADR 0069), keyed by the exact French phrase. See `index.ts`. */
export const SHOP: Readonly<Record<string, string>> = {
  // ui/auction-format.ts
  Casque: 'Helmet',
  Plastron: 'Chestplate',
  Gants: 'Gloves',
  Bottes: 'Boots',
  Arme: 'Weapon',
  'Main gauche': 'Off-hand',
  Ailes: 'Wings',
  Traînée: 'Trail',
  Équipement: 'Equipment',
  Consommable: 'Consumable',
  Matériau: 'Material',
  'Plus récents': 'Newest',
  'Prix croissant': 'Lowest price',
  'Fin proche': 'Ending soon',
  '{amount} or': '{amount} gold',
  Terminé: 'Ended',
  '{hours} h {minutes} min': '{hours}h {minutes}m',
  '{minutes} min': '{minutes} min',
  'L’hôtel des ventes ne répond pas.': 'The Auction House is not responding.',

  // ui/auction-panel.ts
  'Hôtel des ventes': 'Auction House',
  'Fermer (Échap)': 'Close (Esc)',
  Acheter: 'Buy',
  Vendre: 'Sell',
  'Mes lots': 'My lots',

  // ui/auction-buy-view.ts
  'Rechercher un objet': 'Search for an item',
  Emplacement: 'Slot',
  Genre: 'Type',
  Tri: 'Sort',
  Précédente: 'Previous',
  Suivante: 'Next',
  'Recherche…': 'Searching…',
  'Aucun lot ne correspond.': 'No lots match.',
  'Page {page}': 'Page {page}',
  '{seller} · {time}': '{seller} · {time}',
  '{seller} · {time} · {each} l’unité': '{seller} · {time} · {each} each',
  'Il te manque {gold}': '{gold} short',
  'Ton lot': 'Your lot',
  'Sûr ?': 'Sure?',
  'Acheté ! Le lot est dans ton sac.': 'Bought! The lot is in your bag.',

  // ui/auction-sell-view.ts, ui/auction-sell-form.ts
  'Tu as déjà {max} lots en vente : retires-en un d’abord.':
    'You already have {max} lots for sale: withdraw one first.',
  'Rien dans ton sac ne peut être mis en vente.': 'Nothing in your bag can be listed.',
  'Un objet lié ou acheté il y a moins de 14 jours reste dans ton sac.':
    'One bound item, or one bought less than 14 days ago, stays in your bag.',
  '{count} objets liés ou achetés il y a moins de 14 jours restent dans ton sac.':
    '{count} items, bound or bought less than 14 days ago, stay in your bag.',
  Quantité: 'Quantity',
  'Prix du lot': 'Lot price',
  'Le lot reste en vente {hours} h ; invendu, tu le récupères ici.':
    'The lot stays up for {hours} hours; if unsold, you collect it here.',
  '{count} dans ton sac': '{count} in your bag',
  Changer: 'Change',
  'soit {each} l’unité': 'that is {each} each',
  'Commission {rate}': '{rate} fee',
  'Tu recevras': 'You will receive',
  'Indique un prix entre 1 et {max}.': 'Enter a price from 1 to {max}.',
  'Mettre en vente': 'List for sale',
  'Mettre en vente pour {price}': 'List for {price}',
  'Mis en vente : {what} pour {price}.': 'Listed: {what} for {price}.',

  // ui/auction-mine-view.ts
  'En vente': 'On sale',
  Vendu: 'Sold',
  Expiré: 'Expired',
  Retiré: 'Withdrawn',
  Récupéré: 'Collected',
  'Repris (remboursé)': 'Revoked (refunded)',
  'Lots en vente : {active}/{max}': 'Lots for sale: {active}/{max}',
  'Rien en vente pour l’instant.': 'Nothing for sale yet.',
  'Se termine dans {time}': 'Ends in {time}',
  '{status} · à récupérer': '{status} · to collect',
  Retirer: 'Remove',
  Récupérer: 'Collect',
  '{name} t’attend à l’hôtel des ventes : fais de la place dans ton sac.':
    '{name} is waiting at the Auction House: make room in your bag.',
  '{name} revient dans ton sac.': '{name} is back in your bag.',

  // ui/checkout-modal.ts
  Paiement: 'Payment',
  'Paiement sécurisé': 'Secure payment',
  'Ouverture du paiement…': 'Opening payment…',
  'Annuler le paiement (Échap)': 'Cancel payment (Esc)',
  'Carte bancaire, Apple Pay ou Google Pay, traités par Stripe.':
    'Card, Apple Pay or Google Pay, processed by Stripe.',

  // ui/consent-modal.ts
  'Confirmer l’achat': 'Confirm purchase',
  '{offer} : {price}': '{offer}: {price}',
  'Je demande la livraison immédiate et je renonce à mon droit de rétractation.':
    'I request immediate delivery and acknowledge that I waive my right of withdrawal.',
  'Conditions générales de vente': 'Terms of Sale',
  'L’objet arrive dans ton sac dès le paiement confirmé. ':
    'The item arrives in your bag as soon as payment is confirmed. ',
  Payer: 'Pay',
  'Annuler (Échap)': 'Cancel (Esc)',

  // ui/thanks-modal.ts
  'Merci pour ton achat': 'Thank you for your purchase',
  'Merci !': 'Thank you!',
  'Ton achat ': 'Your purchase ',
  ' est arrivé dans le sac de {name}.': ' has arrived in {name}’s bag.',
  'Équipe-les depuis l’onglet Apparence de ton inventaire : ils se portent par-dessus ton équipement.':
    'Equip them from the Appearance tab of your Inventory: they are worn over your Equipment.',
  'Voir mon inventaire': 'View my Inventory',
  'Continuer à jouer': 'Keep playing',

  // ui/shop-cards.ts
  'Édition fondateur': 'Founder Edition',
  'Aurore de la Compagnie': 'Aurora of the Company',
  'Set du dragon': 'Dragon Set',
  'Édition d’Halloween': 'Halloween Edition',
  'Trophées de wyrm': 'Wyrm Trophies',
  'Set sylvestre': 'Sylvan Set',
  'Set des tourbières': 'Bogland Set',
  'Mirages du désert': 'Desert Mirages',
  'Esprits des pics': 'Spirits of the Peaks',
  '-{saving} %': '-{saving}%',
  'Titre offert': 'Title included',
  '« {title} »': '“{title}”',
  'Au-dessus de ton nom, sur tous tes personnages': 'Above your name, on all your Characters',
  'Voir les pièces à l’unité': 'See the pieces one by one',
  'Ouverture…': 'Opening…',
  'Obtenir le pack': 'Get the pack',
  'Tu en as déjà {held} sur {count} : le pack te les redonne tous.':
    'You already have {held} of {count}: the pack gives you all of them again.',
  '{count} objets livrés d’un coup dans ton sac, et le titre.':
    '{count} items delivered to your bag at once, plus the Title.',
  '{count} objets, livrés d’un coup dans ton sac.': '{count} items, delivered to your bag at once.',
  '{count} pièces, {held} déjà à toi': '{count} pieces, {held} already yours',
  '{count} pièces, à l’unité ou ensemble': '{count} pieces, one by one or together',
  'Voir le pack': 'View the pack',
  'Déjà à toi': 'Already yours',
  '+{bonus} % de vitesse': '+{bonus}% speed',
  'La monture la plus rapide du jeu': 'The fastest Mount in the game',

  // ui/shop-panel.ts
  'Cet article n’existe pas.': 'This item does not exist.',
  'Cette offre n’est plus en vente pour cette saison.':
    'This offer is no longer on sale this season.',
  'Cette commande n’existe pas.': 'This order does not exist.',
  'La boutique est fermée pour le moment.': 'The Shop is closed for now.',
  'Cette commande n’est pas à récupérer.': 'This order has nothing to collect.',
  'Ton sac est plein : fais de la place, puis récupère ta commande.':
    'Your bag is full: make room, then collect your order.',
  'Coche la demande de livraison immédiate et de renonciation au droit de rétractation.':
    'Tick the box requesting immediate delivery and waiving the right of withdrawal.',
  'Enregistre ton compte (e-mail, Google ou Steam) pour acheter : un compte invité peut se perdre.':
    'Register your Account (e-mail, Google or Steam) to buy: a Guest account can be lost.',
  'Ce code n’existe pas.': 'This code does not exist.',
  'Ce code a expiré.': 'This code has expired.',
  'Ce code a déjà été utilisé autant de fois que prévu.':
    'This code has already been used as many times as allowed.',
  'Ton compte a déjà reçu ce cadeau.': 'Your Account has already received this gift.',
  'Le paiement est indisponible, réessaie plus tard.':
    'Payment is unavailable, please try again later.',
  'Serveur injoignable.': 'Server unreachable.',
  Boutique: 'Shop',
  'Des cosmétiques par-dessus ton équipement : le look change, pas les stats.':
    'Cosmetics over your Equipment: the look changes, not the stats.',
  'J’ai un code cadeau': 'I have a gift code',
  'Paiement sécurisé par Stripe, en euros, livré dans le sac de {name}. Un achat s’échange ou se vend à l’hôtel des ventes quatorze jours après sa livraison, jamais au marchand.':
    'Secure payment by Stripe, in euros, delivered to {name}’s bag. A purchase can be traded or sold at the Auction House fourteen days after delivery, never to a Merchant.',
  'Paiement en cours de confirmation…': 'Confirming payment…',
  'Livré dans ton sac : {name}. Merci !': 'Delivered to your bag: {name}. Thank you!',
  '{name} est payé, mais ton sac est plein : fais de la place, puis récupère-le ci-dessous.':
    '{name} is paid, but your bag is full: make room, then collect it below.',
  'Paiement annulé.': 'Payment cancelled.',
  'Le paiement n’est pas encore confirmé. Il arrivera dans ton sac dès que Stripe l’aura validé.':
    'Payment not confirmed yet. It will arrive in your bag as soon as Stripe approves it.',
  'Paiement annulé : rien n’a été débité.': 'Payment cancelled: nothing was charged.',
  'Créer mon compte': 'Create my Account',
  'Action impossible.': 'Cannot do that.',
  'Code cadeau': 'Gift code',
  Valider: 'Confirm',
  'Vérification du code…': 'Checking the code…',
  'Code accepté : {names} dans ton sac.': 'Code accepted: {names} in your bag.',
  'Autres packs': 'Other packs',
  'À la pièce': 'Single pieces',
  '← Retour à la boutique': '← Back to the Shop',
  'Les pièces à l’unité': 'The pieces one by one',
  'Paiement en cours…': 'Payment in progress…',
  'Le paiement n’a pas pu s’ouvrir. Réessaie, ou désactive un bloqueur de publicité.':
    'The payment could not open. Try again, or turn off your ad blocker.',
  '{name} : payé, à récupérer': '{name}: paid, to collect',
  '{name} : en attente du paiement': '{name}: awaiting payment',
  'Livré dans ton sac : {name}.': 'Delivered to your bag: {name}.',

  // ui/trade-text.ts
  "Proposition d'échange envoyée à {name}.": 'Trade request sent to {name}.',
  "{name} décline l'échange.": '{name} declines the Trade.',
  "{name} n'a pas répondu à la proposition d'échange.": '{name} did not answer the Trade request.',
  "L'échange avec {name} est annulé.": 'The Trade with {name} is cancelled.',
  'Échange conclu avec {name}.': 'Trade completed with {name}.',
  "Trop loin de {name} : l'échange est rompu.": 'Too far from {name}: the Trade is broken off.',
  "{name} n'est plus là : l'échange est rompu.": '{name} is gone: the Trade is broken off.',
  'Demande refusée.': 'Request refused.',
  "Personne de ce nom n'est dans la zone.": 'Nobody by that name is in the Zone.',
  'Tu ne peux pas échanger avec toi-même.': 'You cannot trade with yourself.',
  'Approche-toi de ce joueur pour échanger.': 'Get closer to this player to trade.',
  'Ce joueur est déjà occupé.': 'This player is already busy.',
  "Un mort n'échange rien.": 'The dead trade nothing.',
  'Une proposition attend déjà sa réponse.': 'A request is already waiting for an answer.',
  "Cette proposition n'est plus valable.": 'This request is no longer valid.',
  "Tu n'es pas en train d'échanger.": 'You are not trading.',
  "Tu n'as plus cet objet dans ton sac.": 'That item is no longer in your bag.',
  "Tu n'en as pas autant.": 'You do not have that many.',
  'Cette pièce est liée : elle ne se donne pas.': 'This piece is bound: it cannot be given away.',
  'Un achat de la boutique ne s’échange pas avant quatorze jours.':
    'A Shop purchase cannot be traded for fourteen days.',
  "Ta bourse n'y suffit pas.": 'You do not have enough gold.',
  'Un des deux sacs est plein.': 'One of the two bags is full.',
  'Le serveur redémarre : échange impossible pour l’instant.':
    'The server is restarting: no trading for now.',

  // ui/trade-client.ts
  '{name} veut échanger avec toi.': '{name} wants to trade with you.',
  '{max} piles au plus sur la table.': '{max} stacks at most on the table.',
  Échanger: 'Trade',

  // ui/trade-panel.ts
  Échange: 'Trade',
  'Or :': 'Gold:',
  'Échange avec {name}': 'Trade with {name}',
  Moi: 'Me',
  Validé: 'Confirmed',
  'A validé': 'Confirmed',
  'En attente': 'Waiting',
  '{max} piles au plus : retire un objet pour en ajouter un autre.':
    '{max} stacks at most: remove an item to add another.',
  'Touche un objet de ton sac, puis « Tout » pour la pile entière. Touche une pile ici pour la reprendre.':
    'Tap an item in your bag, then “All” for the whole stack. Tap a stack here to take it back.',
  "Clique un objet de ton sac pour l'ajouter (Maj : toute la pile). Clique une pile ici pour la reprendre.":
    'Click an item in your bag to add it (Shift: the whole stack). Click a stack here to take it back.',
  'Validé ✓': 'Confirmed ✓',
  'Rien pour l’instant.': 'Nothing yet.',
  'Or : {gold}': 'Gold: {gold}',
  Reprendre: 'Take back',
};
